import { API } from "@/services"

export const MODALS_ENDPOINTS = {
  create(data={}){
    return API.Axios.universal_ai.v1.request({
      url: `modals`,
      method: 'POST',
      data,
    })
  },
  get(params={}){
    return API.Axios.universal_ai.v1.request({
      url: `modals`,
      method: 'GET',
      params,
    })
  },
  findById(id,params={}){
    return API.Axios.universal_ai.v1.request({
      url: `modals/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={}){
    return API.Axios.universal_ai.v1.request({
      url: `modals/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(id='',data={}){
    return API.Axios.universal_ai.v1.request({
      url: `modals/${id}`,
      method: 'PUT',
      data,
    })
  },
}